import { useRouter } from 'next/router';
import { useState } from 'react';

import { emailRegex } from '../../../utils/regex';
import { pageRoute } from '../../../config/routes/pages';
import ErrorMessage from '../../atoms/error-message/error-message';
import EmailOnlyForms from '../email-only-forms/email-only-forms';
import SocialMediaIcons from '../social-media-icons/social-media-icons';
import SubscribeModal from '../subscribe-modal/subscribe-modal';

export function SocialMediaShareSection() {
  const router = useRouter();

  const [subscriptionEmail, setSubscriptionEmail] = useState('');
  const [isSubscribeModalOpen, setIsSubscribeModalOpen] = useState(false);
  const [shouldDisplaySubscribeError, setShouldDisplaySubscribeError] =
    useState(false);
  const [
    shouldDisplayRequestQuotationError,
    setShouldDisplayRequestQuotationError
  ] = useState(false);

  function handleSubscribe(emailInput: string) {
    if (emailRegex.test(emailInput)) {
      setSubscriptionEmail(emailInput);
      setIsSubscribeModalOpen(true);
    } else setShouldDisplaySubscribeError(true);
  }

  function handleQuotation(emailInput: string) {
    if (emailRegex.test(emailInput)) {
      router.push(
        `${pageRoute.ABOUT_REQUEST_FOR_QUOTATION}?email=${emailInput}`
      );
    } else setShouldDisplayRequestQuotationError(true);
  }

  const shareText = false && (
    <h4 className="font-MuseoSans100 text-header5 mt-10 text-darkGreen font-bold">
      SHARE
    </h4>
  );
  const socialMediaIcons = false && <SocialMediaIcons />;

  return (
    <>
      <SubscribeModal
        emailValue={subscriptionEmail}
        isOpen={isSubscribeModalOpen}
        setIsOpen={setIsSubscribeModalOpen}
      />
      <div className="bg-headerBackground flex flex-col items-center justify-center">
        {shareText}
        {socialMediaIcons}
        <div className="flex flex-col lg:flex-row my-10 justify-center items-center lg:items-stretch space-y-5 px-4 lg:space-y-0 lg:space-x-16 w-full h-full">
          <div className="flex flex-col">
            <EmailOnlyForms
              description="Sign up to our e-newsletter for brand updates and special offers!"
              handleActionButton={handleSubscribe}
              header="Let's Stay Connected"
              placeholder="Your Email"
            />
            <ErrorMessage
              errorMessage="Invalid input!"
              shouldDisplayMessage={shouldDisplaySubscribeError}
            />
          </div>
          <div className="h-inherit w-[0.1px] bg-gray-400/50 hidden lg:block" />
          <div className="flex flex-col">
            <EmailOnlyForms
              description="Learn more about Sub-Zero and Wolf' products."
              handleActionButton={handleQuotation}
              header="Request For Quotation"
              placeholder="Your Email"
            />
            <ErrorMessage
              errorMessage="Invalid input!"
              shouldDisplayMessage={shouldDisplayRequestQuotationError}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default SocialMediaShareSection;
